import Vue from "vue";
import Router from "vue-router";
import store from "@/store";
import i18n from "@/locales";
// Authentication
import Authentication from "@/views/authentication/Authentication";
import ExpiredPassword from "@/views/authentication/ExpiredPassword";
import ForgetPassword from "@/views/authentication/ForgetPassword";
import ResetPassword from "@/views/authentication/ResetPassword";
import SignIn from "@/views/authentication/SignIn";
// Error HTTP  views
import Error401 from "@/views/error/401";
import Error404 from "@/views/error/404";
import Error503 from "@/views/error/503";
import ExpiredPwdMessage from "@/views/authentication/ExpiredPwdMessage";
import ForgetPwdMessage from "@/views/authentication/ForgetPwdMessage";
import SessionExpiredMessage from "@/views/authentication/SessionExpiredMessage";
// Views
import Feeds from "@/views/home/Feeds";
import Home from "@/views/home/Home";
// Seguridad
import Usuario from "@/views/seguridad/usuario/Usuario";
import Perfil from "@/views/seguridad/perfil/Perfil";
import PerfilUsuario from "@/views/seguridad/perfilUsuario/PerfilUsuario";
// Generales
import PlantillaCorreo from "@/views/generales/plantillaCorreo/PlantillaCorreo";
import Parametros from "@/views/generales/parametros/Parametros";
import Archivos from "@/views/generales/archivos/Archivos";
// Bitacoras
import Bitacora from "@/views/bitacoras/bitacora/Bitacora";
import ReporteAuditoria from "@/views/bitacoras/reporteAuditoria/ReporteAuditoria";
import MonitorCorreos from "@/views/bitacoras/monitorCorreos/MonitorCorreos";
import BitacoraGeolocalizacion from "@/views/bitacoras/geolocalizacion/BitacoraGeolocalizacion";
// Operativos
import Status from "@/views/operativos/status/Status";
import SubStatus from "@/views/operativos/substatus/SubStatus";
import Accion from "@/views/operativos/accion/Accion";
import Vendor from "@/views/operativos/vendor/Vendor";
import Rep from "@/views/operativos/rep/Rep";
import Campana from "@/views/operativos/campana/Campana";
import Agregador from "@/views/operativos/agregador/Agregador";
import BenefPref from "@/views/operativos/benefpref/BenefPref";
import Tipo from "@/views/operativos/tipo/Tipo";
import Contact from "@/views/operativos/contact/Contact";
import PopEntryExit from "@/views/operativos/popEntryExit/PopEntryExit";
import PosTest from "@/views/operativos/posTest/PosTest";
import StatusPreContacto from "@/views/operativos/statusPreContacto/StatusPreContacto";
import Shoppings from "@/views/operativos/shoppings/Shoppings";
import Se from "@/views/operativos/se/Se";
import SeOOB from "@/views/operativos/seOOB/SeOOB";
import Acuerdo from "@/views/operativos/acuerdo/Acuerdo";
import SubIndustria from "@/views/operativos/subindustria/SubIndustria";
import Banco from "@/views/operativos/banco/Banco";
import CodigoIndustrial from "@/views/operativos/codigoindustrial/CodigoIndustrial";
import Partner from "@/views/operativos/partner/Partner";
import ProveedorPos from "@/views/operativos/proveedorpos/ProveedorPos";
import Merchandising from "@/views/operativos/merchandising/Merchandising";
import CanalAceptacion from "@/views/operativos/canalaceptacion/CanalAceptacion";
import Iniciativa from "@/views/operativos/iniciativa/Iniciativa";
import MotivoBaja from "@/views/operativos/motivobaja/MotivoBaja";
// Geograficos
import Provincia from "@/views/geograficos/provincia/Provincia";
import Localidad from "@/views/geograficos/localidad/Localidad";
import Pais from "@/views/geograficos/pais/Pais";
import Lada from "@/views/geograficos/lada/Lada";
// FileTransaction
import Validator from "@/views/filetransaction/validator/Validator";
import Importer from "@/views/filetransaction/importer/Importer";
// Bases
import Base from "@/views/bases/base/Base";
// Reportes
import ReporteExclusiones from "@/views/reportes/reporteexclusiones/ReporteExclusiones";
import ReporteUsuarios from "@/views/reportes/reporteusuarios/ReporteUsuarios";
import ReporteVisitas from "@/views/reportes/reportevisitas/ReporteVisitas";

Vue.use(Router);

const isNotAuthenticated = (_to, _from, next) => {
  if (!store.getters.getUserIsAuthenticated) {
    next();
    return;
  }
  next("/home");
};

const isAuthenticated = (_to, _from, next) => {
  if (store.getters.getUserIsAuthenticated) {
    next();
    return;
  }
  next("/auth");
};

export default new Router({
  mode: "history"
  , routes: [
    /* AUTENTICATION */
    {
      path: ""
      , redirect: "/auth"
    }
    , {
      path: "/auth"
      , component: Authentication
      , beforeEnter: isNotAuthenticated
      , children: [
        {
          path: ""
          , name: "SignIn"
          , component: SignIn
        }
        , {
          path: "expiredpwd"
          , name: "ExpiredPassword"
          , component: ExpiredPassword
        }
        , {
          path: "forgetpwd"
          , name: "ForgetPassword"
          , component: ForgetPassword
        }
        , {
          path: "resetpwd"
          , name: "ResetPassword"
          , component: ResetPassword
        }
      ]
    }
    /* MESSAGES */
    , {
      path: "/sessionexpiredmessage"
      , name: "SessionExpiredMessage"
      , component: SessionExpiredMessage
    }
    , {
      path: "/expiredpwdmessage"
      , name: "ExpiredPwdMessage"
      , component: ExpiredPwdMessage
    }
    , {
      path: "/forgetpwdmessage"
      , name: "ForgetPwdMessage"
      , component: ForgetPwdMessage
    }
    /* ERRORS */
    , {
      path: "/404NotFound"
      , name: "PageNotFound"
      , component: Error404
    }
    , {
      path: "/401Unauthorized"
      , name: "401Unauthorized"
      , component: Error401
    }
    , {
      path: "/503Error"
      , name: "serviceUnavailable"
      , component: Error503
    }
    /* VIEWS */
    , {
      path: "/home"
      , component: Home
      , beforeEnter: isAuthenticated
      , children: [
        {
          path: ""
          , name: "Feeds"
          , component: Feeds
          , meta: {
            permissions: [
              {
                role: "ROLE_ACCESO_ACH"
                , access: true
                , redirect: "401Unauthorized"
              }
            ]
          }
        }
        /* SEGURIDAD */
        , {
          path: "usuario"
          , name: "Usuario"
          , component: Usuario
          , meta: {
            bitacora: "Users"
            , breadcrumb: i18n.t("view.menu.seguridad.sub.usuario.text")
            , permissions: [
              {
                role: "ROLE_ACCESO_SEGURIDAD"
                , access: true
                , redirect: "Feeds"
              }
            ]
          }
        }
        , {
          path: "perfiles"
          , name: "Perfil"
          , component: Perfil
          , meta: {
            bitacora: "Groups"
            , breadcrumb: i18n.t("view.menu.seguridad.sub.perfiles.text")
            , permissions: [
              {
                role: "ROLE_ACCESO_SEGURIDAD"
                , access: true
                , redirect: "Feeds"
              }
            ]
          }
        }
        , {
          path: "perfilUsuario"
          , name: "PerfilUsuario"
          , component: PerfilUsuario
          , meta: {
            bitacora: "PerfilUsuarioDTO"
            , breadcrumb: i18n.t("view.menu.seguridad.sub.perfilUsuario.text")
            , permissions: [
              {
                role: "ROLE_ACCESO_ACH"
                , access: true
                , redirect: "Feeds"
              }
            ]
          }
        }
        /* OPERATIVOS */
        , {
          path: "status"
          , name: "Status"
          , component: Status
          , meta: {
            bitacora: "TStatus"
            , breadcrumb: i18n.t("view.menu.catalogosOperativos.sub.status.text")
            , permissions: [
              {
                role: "ROLE_ACCESO_OP"
                , access: true
                , redirect: "Feeds"
              }
            ]
          }
        }
        , {
          path: "substatus"
          , name: "SubStatus"
          , component: SubStatus
          , meta: {
            bitacora: "TSubStatus"
            , breadcrumb: i18n.t("view.menu.catalogosOperativos.sub.substatus.text")
            , permissions: [
              {
                role: "ROLE_ACCESO_OP"
                , access: true
                , redirect: "Feeds"
              }
            ]
          }
        }
        , {
          path: "accion"
          , name: "Accion"
          , component: Accion
          , meta: {
            bitacora: "TAccion"
            , breadcrumb: i18n.t("view.menu.catalogosOperativos.sub.accion.text")
            , permissions: [
              {
                role: "ROLE_ACCESO_OP"
                , access: true
                , redirect: "Feeds"
              }
            ]
          }
        }
        , {
          path: "vendor"
          , name: "Vendor"
          , component: Vendor
          , meta: {
            bitacora: "TVendor"
            , breadcrumb: i18n.t("view.menu.catalogosOperativos.sub.vendor.text")
            , permissions: [
              {
                role: "ROLE_ACCESO_OP"
                , access: true
                , redirect: "Feeds"
              }
            ]
          }
        }
        , {
          path: "rep"
          , name: "Rep"
          , component: Rep
          , meta: {
            bitacora: "TRep"
            , breadcrumb: i18n.t("view.menu.catalogosOperativos.sub.rep.text")
            , permissions: [
              {
                role: "ROLE_ACCESO_OP"
                , access: true
                , redirect: "Feeds"
              }
            ]
          }
        }
        , {
          path: "campana"
          , name: "Campana"
          , component: Campana
          , meta: {
            bitacora: "TCampana"
            , breadcrumb: i18n.t("view.menu.catalogosOperativos.sub.campana.text")
            , permissions: [
              {
                role: "ROLE_ACCESO_OP"
                , access: true
                , redirect: "Feeds"
              }
            ]
          }
        }
        , {
          path: "agregador"
          , name: "Agregador"
          , component: Agregador
          , meta: {
            bitacora: "TAgregador"
            , breadcrumb: i18n.t("view.menu.catalogosOperativos.sub.agregador.text")
            , permissions: [
              {
                role: "ROLE_ACCESO_OP"
                , access: true
                , redirect: "Feeds"
              }
            ]
          }
        }
        , {
          path: "benefpref"
          , name: "BenefPref"
          , component: BenefPref
          , meta: {
            bitacora: "TBenefPref"
            , breadcrumb: i18n.t("view.menu.catalogosOperativos.sub.benefpref.text")
            , permissions: [
              {
                role: "ROLE_ACCESO_OP"
                , access: true
                , redirect: "Feeds"
              }
            ]
          }
        }
        , {
          path: "tipo"
          , name: "Tipo"
          , component: Tipo
          , meta: {
            bitacora: "TTipo"
            , breadcrumb: i18n.t("view.menu.catalogosOperativos.sub.tipo.text")
            , permissions: [
              {
                role: "ROLE_ACCESO_OP"
                , access: true
                , redirect: "Feeds"
              }
            ]
          }
        }
        , {
          path: "contact"
          , name: "Contact"
          , component: Contact
          , meta: {
            bitacora: "TContact"
            , breadcrumb: i18n.t("view.menu.catalogosOperativos.sub.contact.text")
            , permissions: [
              {
                role: "ROLE_ACCESO_OP"
                , access: true
                , redirect: "Feeds"
              }
            ]
          }
        }
        , {
          path: "shoppings"
          , name: "Shoppings"
          , component: Shoppings
          , meta: {
            bitacora: "TShoppings"
            , breadcrumb: i18n.t("view.menu.catalogosOperativos.sub.shoppings.text")
            , permissions: [
              {
                role: "ROLE_ACCESO_OP"
                , access: true
                , redirect: "Feeds"
              }
            ]
          }
        }
        , {
          path: "posTest"
          , name: "PosTest"
          , component: PosTest
          , meta: {
            bitacora: "TPosTest"
            , breadcrumb: i18n.t("view.menu.catalogosOperativos.sub.posTest.text")
            , permissions: [
              {
                role: "ROLE_ACCESO_OP"
                , access: true
                , redirect: "Feeds"
              }
            ]
          }
        }
        , {
          path: "statusPreContacto"
          , name: "StatusPreContacto"
          , component: StatusPreContacto
          , meta: {
            bitacora: "TStatusPreContacto"
            , breadcrumb: i18n.t("view.menu.catalogosOperativos.sub.statusPreContacto.text")
            , permissions: [
              {
                role: "ROLE_ACCESO_OP"
                , access: true
                , redirect: "Feeds"
              }
            ]
          }
        }
        , {
          path: "popEntryExit"
          , name: "PopEntryExit"
          , component: PopEntryExit
          , meta: {
            bitacora: "TPopEntryExit"
            , breadcrumb: i18n.t("view.menu.catalogosOperativos.sub.popEntryExit.text")
            , permissions: [
              {
                role: "ROLE_ACCESO_OP"
                , access: true
                , redirect: "Feeds"
              }
            ]
          }
        }
        , {
          path: "se"
          , name: "Se"
          , component: Se
          , meta: {
            bitacora: "TSe"
            , breadcrumb: i18n.t("view.menu.catalogosOperativos.sub.se.text")
            , permissions: [
              {
                role: "ROLE_ACCESO_OP"
                , access: true
                , redirect: "Feeds"
              }
            ]
          }
        }
        , {
          path: "seOOB"
          , name: "SeOOB"
          , component: SeOOB
          , meta: {
            bitacora: "TSeOOB"
            , breadcrumb: i18n.t("view.menu.catalogosOperativos.sub.seOOB.text")
            , permissions: [
              {
                role: "ROLE_ACCESO_OP"
                , access: true
                , redirect: "Feeds"
              }
            ]
          }
        }
        , {
          path: "acuerdo"
          , name: "Acuerdo"
          , component: Acuerdo
          , meta: {
            bitacora: "TAcuerdo"
            , breadcrumb: i18n.t("view.menu.bases.sub.acuerdo.text")
            , permissions: [
              {
                role: "ROLE_ACCESO_OP"
                , access: true
                , redirect: "Feeds"
              }
            ]
          }
        }
        , {
          path: "subindustria"
          , name: "SubIndustria"
          , component: SubIndustria
          , meta: {
            bitacora: "TSubIndustria"
            , breadcrumb: i18n.t("view.menu.bases.sub.subindustria.text")
            , permissions: [
              {
                role: "ROLE_ACCESO_OP"
                , access: true
                , redirect: "Feeds"
              }
            ]
          }
        }
        , {
          path: "banco"
          , name: "Banco"
          , component: Banco
          , meta: {
            bitacora: "TBanco"
            , breadcrumb: i18n.t("view.menu.bases.sub.banco.text")
            , permissions: [
              {
                role: "ROLE_ACCESO_OP"
                , access: true
                , redirect: "Feeds"
              }
            ]
          }
        }
        , {
          path: "codigoindustrial"
          , name: "CodigoIndustrial"
          , component: CodigoIndustrial
          , meta: {
            bitacora: "TCodigoIndustrial"
            , breadcrumb: i18n.t("view.menu.bases.sub.codigoindustrial.text")
            , permissions: [
              {
                role: "ROLE_ACCESO_OP"
                , access: true
                , redirect: "Feeds"
              }
            ]
          }
        }
        , {
          path: "partner"
          , name: "Partner"
          , component: Partner
          , meta: {
            bitacora: "TPartner"
            , breadcrumb: i18n.t("view.menu.bases.sub.partner.text")
            , permissions: [
              {
                role: "ROLE_ACCESO_OP"
                , access: true
                , redirect: "Feeds"
              }
            ]
          }
        }
        , {
          path: "proveedorpos"
          , name: "ProveedorPos"
          , component: ProveedorPos
          , meta: {
            bitacora: "TProveedorPos"
            , breadcrumb: i18n.t("view.menu.bases.sub.proveedorpos.text")
            , permissions: [
              {
                role: "ROLE_ACCESO_OP"
                , access: true
                , redirect: "Feeds"
              }
            ]
          }
        }
        , {
          path: "merchandising"
          , name: "Merchandising"
          , component: Merchandising
          , meta: {
            bitacora: "TMerchandising"
            , breadcrumb: i18n.t("view.menu.bases.sub.merchandising.text")
            , permissions: [
              {
                role: "ROLE_ACCESO_OP"
                , access: true
                , redirect: "Feeds"
              }
            ]
          }
        }
        , {
          path: "canalaceptacion"
          , name: "CanalAceptacion"
          , component: CanalAceptacion
          , meta: {
            bitacora: "TCanalAceptacion"
            , breadcrumb: i18n.t("view.menu.bases.sub.canalaceptacion.text")
            , permissions: [
              {
                role: "ROLE_ACCESO_OP"
                , access: true
                , redirect: "Feeds"
              }
            ]
          }
        }
        , {
          path: "iniciativa"
          , name: "Iniciativa"
          , component: Iniciativa
          , meta: {
            bitacora: "TIniciativa"
            , breadcrumb: i18n.t("view.menu.catalogosOperativos.sub.iniciativa.text")
            , permissions: [
              {
                role: "ROLE_ACCESO_OP"
                , access: true
                , redirect: "Feeds"
              }
            ]
          }
        }
        , {
          path: "motivobaja"
          , name: "MotivoBaja"
          , component: MotivoBaja
          , meta: {
            bitacora: "TMotivoBaja"
            , breadcrumb: i18n.t("view.menu.catalogosOperativos.sub.motivobaja.text")
            , permissions: [
              {
                role: "ROLE_ACCESO_OP"
                , access: true
                , redirect: "Feeds"
              }
            ]
          }
        }
        /* GEOGRAFICOS */
        , {
          path: "provincia"
          , name: "Provincia"
          , component: Provincia
          , meta: {
            bitacora: "TProvincia"
            , breadcrumb: i18n.t("view.menu.catalogosGeograficos.sub.provincia.text")
            , permissions: [
              {
                role: "ROLE_ACCESO_GR"
                , access: true
                , redirect: "Feeds"
              }
            ]
          }
        }
        , {
          path: "localidad"
          , name: "Localidad"
          , component: Localidad
          , meta: {
            bitacora: "TLocalidad"
            , breadcrumb: i18n.t("view.menu.catalogosGeograficos.sub.localidad.text")
            , permissions: [
              {
                role: "ROLE_ACCESO_GR"
                , access: true
                , redirect: "Feeds"
              }
            ]
          }
        }
        , {
          path: "pais"
          , name: "Pais"
          , component: Pais
          , meta: {
            bitacora: "TPais"
            , breadcrumb: i18n.t("view.menu.catalogosGeograficos.sub.pais.text")
            , permissions: [
              {
                role: "ROLE_ACCESO_GR"
                , access: true
                , redirect: "Feeds"
              }
            ]
          }
        }
        , {
          path: "codigo-telefonico"
          , name: "Lada"
          , component: Lada
          , meta: {
            bitacora: "TLada"
            , breadcrumb: i18n.t("view.menu.catalogosGeograficos.sub.lada.text")
            , permissions: [
              {
                role: "ROLE_ACCESO_GR"
                , access: true
                , redirect: "Feeds"
              }
            ]
          }
        }
        /* GENERALES */
        , {
          path: "plantillaCorreo"
          , name: "PlantillaCorreo"
          , component: PlantillaCorreo
          , meta: {
            bitacora: "TPlantillaCorreo"
            , breadcrumb: i18n.t("view.menu.catalogosGenerales.sub.plantillasCorreo.text")
            , permissions: [
              {
                role: "ROLE_ACCESO_CATALOGOS"
                , access: true
                , redirect: "Feeds"
              }
            ]
          }
        }
        , {
          path: "parametros"
          , name: "Parametros"
          , component: Parametros
          , meta: {
            bitacora: "TParametros"
            , breadcrumb: i18n.t("view.menu.catalogosGenerales.sub.parametros.text")
            , permissions: [
              {
                role: "ROLE_ACCESO_CATALOGOS"
                , access: true
                , redirect: "Feeds"
              }
            ]
          }
        }
        , {
          path: "archivos"
          , name: "Archivos"
          , component: Archivos
          , meta: {
            bitacora: "TArchivos"
            , breadcrumb: i18n.t("view.menu.catalogosGenerales.sub.archivos.text")
            , permissions: [
              {
                role: "ROLE_ACCESO_CATALOGOS"
                , access: true
                , redirect: "Feeds"
              }
            ]
          }
        }
        /* BITACORAS */
        , {
          path: "bitacora"
          , name: "Bitacora"
          , component: Bitacora
          , meta: {
            bitacora: "TBitacora"
            , breadcrumb: i18n.t("view.menu.consultaBitacoras.sub.bitacora.text")
            , permissions: [
              {
                role: "ROLE_ACCESO_BITACORA"
                , access: true
                , redirect: "Feeds"
              }
            ]
          }
        }
        , {
          path: "reporteAuditoria"
          , name: "ReporteAuditoria"
          , component: ReporteAuditoria
          , meta: {
            bitacora: "ReporteAuditoriaDTO"
            , breadcrumb: i18n.t("view.menu.consultaBitacoras.sub.reportesAuditoria.text")
            , permissions: [
              {
                role: "ROLE_ACCESO_REPORTES_AUDITORIA"
                , access: true
                , redirect: "Feeds"
              }
            ]
          }
        }
        , {
          path: "monitorNotificaciones"
          , name: "MonitorCorreos"
          , component: MonitorCorreos
          , meta: {
            bitacora: "TCorreo"
            , breadcrumb: i18n.t("view.menu.consultaBitacoras.sub.monitorCorreos.text")
            , permissions: [
              {
                role: "ROLE_ACCESO_BITACORA"
                , access: true
                , redirect: "Feeds"
              }
            ]
          }
        }
        , {
          path: "bitacoraGeolocalizacion"
          , name: "BitacoraGeolocalizacion"
          , component: BitacoraGeolocalizacion
          , meta: {
            bitacora: "BitacoraGeolocalizacion"
            , breadcrumb: i18n.t("view.menu.consultaBitacoras.sub.geolocalizacion.text")
            , permissions: [
              {
                role: "ROLE_ACCESO_TTS_BITACORA_GEOLOCALIZACION"
                , access: true
                , redirect: "Feeds"
              }
            ]
          }
        }
        /* FILETRANSACTION */
        , {
          path: "validator"
          , name: "Validator"
          , component: Validator
          , meta: {
            bitacora: "TFileTransaction"
            , breadcrumb: i18n.t("view.menu.filetransaction.validator.text")
            , permissions: [
              {
                role: "ROLE_ACCESO_VACH"
                , access: true
                , redirect: "Feeds"
              }
            ]
          }
        }
        /*  BASE */
        , {
          path: "base"
          , name: "Base"
          , component: Base
          , meta: {
            bitacora: "BaseDTO"
            , breadcrumb: i18n.t("view.menu.base.text")
            , permissions: [
              {
                role: "ROLE_ACCESO_BASE"
                , access: true
                , redirect: "Feeds"
              }
            ]
          }
        }
        /* IMPORTADOR */
        , {
          path: "importer"
          , name: "Importer"
          , component: Importer
          , meta: {
            bitacora: "TFileTransaction"
            , breadcrumb: i18n.t("view.menu.filetransaction.importer.text")
            , permissions: [
              {
                role: "ROLE_ACCESO_IACH"
                , access: true
                , redirect: "Feeds"
              }
            ]
          }
        }
        /* REPORTES */
        , {
          path: "reporteexclusiones"
          , name: "ReporteExclusiones"
          , component: ReporteExclusiones
          , meta: {
            bitacora: "ReporteExclusiones"
            , breadcrumb: i18n.t("view.menu.reportes.sub.reporteexclusiones.text")
            , permissions: [
              {
                role: "ROLE_ACCESO_REPORTEEXCLUSIONES"
                , access: true
                , redirect: "Feeds"
              }
            ]
          }
        }
        , {
          path: "reporteusuarios"
          , name: "ReporteUsuarios"
          , component: ReporteUsuarios
          , meta: {
            bitacora: "ReporteUsuarios"
            , breadcrumb: i18n.t("view.menu.reportes.sub.reporteusuarios.text")
            , permissions: [
              {
                role: "ROLE_ACCESO_REPORTEUSUARIOS"
                , access: true
                , redirect: "Feeds"
              }
            ]
          }
        }
        , {
          path: "reportevisitas"
          , name: "ReporteVisitas"
          , component: ReporteVisitas
          , meta: {
            bitacora: "ReporteVisitas"
            , breadcrumb: i18n.t("view.menu.reportes.sub.reportevisitas.text")
            , permissions: [
              {
                role: "ROLE_ACCESO_REPORTEVISITAS"
                , access: true
                , redirect: "Feeds"
              }
            ]
          }
        }
      ]
      , meta: {
        breadcrumb: i18n.t("view.menu.inicio.text")
        , permissions: [
          {
            role: "ROLE_ACCESO_ACH"
            , access: true
            , redirect: "401Unauthorized"
          }
        ]
      }
    }
    , {
      path: "/*"
      , name: "pageNotFound"
      , component: Error404
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js